module.exports = __webpack_public_path__ + "img/defaultPetImage.8e30e078.webp";